import { Song } from "../types/type";

type EventType =
  | "song_play_start_cnt"
  | "song_play_30sec_cnt"
  | "song_play_60sec_cnt"
  | "song_play_90sec_cnt"
  | "song_play_complete_cnt";

export type Row = {
  f: { v: string | number }[];
};

export type ResponseData = {
  kind: string;
  schema: object;
  jobReference: object;
  totalRows: string;
  rows: Row[];
};

export interface UserSongData {
  userId: string;
  song_play_start: Record<string, number>;
  song_play_30sec: Record<string, number>;
  song_play_60sec: Record<string, number>;
  song_play_90sec: Record<string, number>;
  song_play_complete: Record<string, number>;
}

export const formatData = (
  rows: Row[],
  totalSongList: Song[]
): UserSongData[] => {
  const userSongDataMap: Record<string, UserSongData> = {};

  rows.forEach((row) => {
    const userId = row.f[0].v as string;
    const songId = row.f[1].v as string;
    const playCounts = {
      song_play_start_cnt: parseInt(row.f[2].v as string),
      song_play_30sec_cnt: parseInt(row.f[3].v as string),
      song_play_60sec_cnt: parseInt(row.f[4].v as string),
      song_play_90sec_cnt: parseInt(row.f[5].v as string),
      song_play_complete_cnt: parseInt(row.f[6].v as string),
    };

    const song = totalSongList.find((song) => song.songId === songId);
    if (!song) return;

    const genres = song.tag.genreList;

    if (!userSongDataMap[userId]) {
      userSongDataMap[userId] = {
        userId,
        song_play_start: {},
        song_play_30sec: {},
        song_play_60sec: {},
        song_play_90sec: {},
        song_play_complete: {},
      };
    }

    const userSongData = userSongDataMap[userId];

    (Object.keys(playCounts) as EventType[]).forEach((eventType) => {
      const count = playCounts[eventType];
      if (count > 0) {
        genres.forEach((genre) => {
          const eventTypeKey = eventType.replace(
            "_cnt",
            ""
          ) as keyof UserSongData;
          const eventTypeData = userSongData[eventTypeKey] as Record<
            string,
            number
          >;

          if (!eventTypeData[genre]) {
            eventTypeData[genre] = 0;
          }
          eventTypeData[genre] += count;
        });
      }
    });
  });

  return Object.values(userSongDataMap);
};
